import React from 'react';
import ProductTierCard from './ProductTierCard';
import '../styles/ProductTierGrid.css';

interface ProductTier {
  id: string;
  name: string;
  description: string;
  price_id: string;
  amount: number;
  currency: string;
  interval: string;
  features: string[];
  metadata: Record<string, string>;
}

interface UserSubscription {
  subscription_id: string;
  stripe_product_id: string;
  stripe_price_id: string;
  status: string;
  current_period_end: string;
}

interface ProductTierGridProps {
  tiers: ProductTier[];
  currentSubscription: UserSubscription | null;
  onSelectPlan: (tier: ProductTier) => void;
  onPlanChange?: (tier: ProductTier) => void;
  onCancellation?: () => void;
  displayOnly?: boolean; // New prop for home page display
}

const ProductTierGrid: React.FC<ProductTierGridProps> = ({
  tiers,
  currentSubscription,
  onSelectPlan,
  onPlanChange,
  onCancellation,
  displayOnly = false, // Default to false for account page behavior
}) => {
  if (!tiers || tiers.length === 0) {
    return (
      <div className="product-tier-grid">
        <div className="no-tiers-message">
          <p>No subscription plans are currently available.</p>
          <p>Please check back later or contact support if this persists.</p>
        </div>
      </div>
    );
  }

  // Sort tiers by price for consistent display order
  const sortedTiers = [...tiers].sort((a, b) => a.amount - b.amount);

  return (
    <div className="product-tier-grid">
      <div className="tier-grid">
        {sortedTiers.map((tier) => {
          const isCurrentPlan = currentSubscription?.stripe_product_id === tier.id;
          
          return (
            <ProductTierCard
              key={tier.id}
              tier={tier}
              isCurrentPlan={isCurrentPlan}
              hasSubscription={currentSubscription !== null}
              currentSubscription={currentSubscription}
              allTiers={sortedTiers}
              onSelect={() => onSelectPlan(tier)}
              onUpgrade={onPlanChange ? () => onPlanChange(tier) : undefined}
              onDowngrade={onPlanChange ? () => onPlanChange(tier) : undefined}
              onCancel={onCancellation}
              displayOnly={displayOnly}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProductTierGrid;
